export default function TrustSection() {
  const testimonials = [
    {
      name: "Sarah Mitchell",
      handle: "sarah_style",
      text: "OOPBuy Spreadsheet completely changed how I shop online. The structured data makes comparing prices across different sellers so much faster than traditional browsing. I have saved hours every week.",
    },
    {
      name: "James Carter",
      handle: "james_finds",
      text: "As someone who shops for sneakers regularly, the spreadsheet system is a game changer. Everything is organized perfectly and I can track my orders without jumping between multiple websites.",
    },
    {
      name: "Emily Rodriguez",
      handle: "emily_shops",
      text: "I was skeptical at first but OOPBuy Spreadsheet delivered beyond expectations. The comparison tools helped me find the best deals on jackets and accessories. Highly recommend for serious shoppers.",
    },
    {
      name: "David Kim",
      handle: "david_k",
      text: "The transparency of OOPBuy Spreadsheet is unmatched. Seeing all product data in one structured view eliminates the confusion of traditional online shopping. This should be the standard.",
    },
    {
      name: "Lisa Thompson",
      handle: "lisa_t",
      text: "Been using OOPBuy Spreadsheet for three months now and the time savings are incredible. The spreadsheet layout makes it so easy to filter and find exactly what I need across all categories.",
    },
    {
      name: "Michael Brown",
      handle: "mike_deals",
      text: "Finally a shopping system that prioritizes efficiency. OOPBuy Spreadsheet helps me compare hoodies and t-shirts prices across suppliers in seconds rather than spending hours browsing.",
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
            Trusted by Shoppers
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight max-w-2xl">
            What Our Community
            <br />
            Says About OOPBuy Spreadsheet
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="break-inside-avoid mb-4 md:mb-5 bg-background-100 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <span className="text-secondary-700 font-semibold text-sm">
                    {t.name.split(" ").map((n) => n[0]).join("")}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">@{t.handle}</p>
                </div>
              </div>
              <p className="text-foreground-700 text-xs md:text-sm leading-relaxed italic">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-background-100 rounded-xl p-6 md:p-10">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
            Is OOPBuy Spreadsheet Safe?
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
            {[
              { icon: "ri-lock-line", title: "No Direct Payment Processing", desc: "This is an informational and data organization platform" },
              { icon: "ri-eye-off-line", title: "No Personal Data Storage", desc: "We do not collect or store sensitive user information" },
              { icon: "ri-link-unlink", title: "Transparent External Linking", desc: "All external platform links are clearly identified" },
              { icon: "ri-user-settings-line", title: "User-Controlled Flow", desc: "You decide every step of your shopping journey" },
            ].map((item, i) => (
              <div key={i} className="flex gap-3">
                <div className="w-9 h-9 rounded-md bg-secondary-100 text-secondary-600 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.title}</p>
                  <p className="text-xs text-foreground-600 mt-0.5">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="text-xs text-foreground-500 italic border-t border-background-200/70 pt-4">
            Disclaimer: This website is an informational and affiliate guide platform. Users are responsible for verifying all external platform transactions and policies.
          </p>
        </div>
      </div>
    </section>
  );
}